import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import CategoryService from '../services/CategoryService';
import { isEmpty } from 'lodash';

const initialState = {
  data: [],
  datas: [],
  parent_datas: [],
  formError: [],
  pagination: {
    page: 0,
    per_page: 10,
    total: 10,
    totalPages: 10,
  },
  loading: false,
  isSuccess: false,
  submitLoading: false,
  isOpenCategoryDialog: false
};

export const fetchCategoryList = createAsyncThunk(
  'category/fetchCategoryList',
  async ({ perPage, page, keyword, type = '' }) => {
    try {
      const resp = await CategoryService.List({ perPage, page, keyword, type });
      return resp;
    } catch (e) {
      return e.response;
    }
  },
);

export const createCategory = createAsyncThunk('category/createCategory', async (data, { rejectWithValue }) => {
  try {
    const resp = await CategoryService.Create(data);
    return resp;
  } catch (error) {
    return rejectWithValue(error.response);
  }
});

export const updateCategory = createAsyncThunk('category/updateCategory',
  async (payload, { rejectWithValue }) => {
    try {
      const resp = await CategoryService.Put(payload);
      return resp;
    } catch (error) {
      return rejectWithValue(error.response);
    }
  }
);

export const deleteCategory = createAsyncThunk('category/deleteCategory', async (id) => {
  try {
    const resp = await CategoryService.Delt(id);
    return resp;
  } catch (e) {
    return e.response;
  }
});

const categorySlice = createSlice({
  name: 'category',
  initialState: initialState,
  reducers: {
    openCategoryDialog: (state, action) => {
      state.isOpenCategoryDialog = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCategoryList.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(fetchCategoryList.fulfilled, (state, action) => {
        if (action.payload?.status === 200) {
          state.datas = [...action.payload?.data.data?.categoryList];
          state.pagination = action.payload?.data.data?.pagination;
        } else {
          state.error = action.payload?.data.message;
          toast.error(state.error);
        }
        state.loading = false;
      })
      .addCase(fetchCategoryList.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(createCategory.pending, (state, action) => {
        state.submitLoading = true;
        state.isSuccess = false;
      })
      .addCase(createCategory.fulfilled, (state, action) => {
        state.datas.unshift(action.payload.data.data);
        state.isSuccess = true;
        toast.success(action.payload?.message);
        state.pagination = {
          ...state.pagination,
          total: state.pagination.total + 1,
        };
        state.submitLoading = false;
      })
      .addCase(createCategory.rejected, (state, action) => {
        state.submitLoading = false;
        state.isSuccess = false;
        const errors = action.payload?.data?.errors;
        if (isEmpty(errors)) {
          toast.error(action.payload?.data?.message || 'Something went wrong');
        } else {
          state.formError = errors;
        }
      })
      .addCase(updateCategory.pending, (state, action) => {
        state.isSuccess = false;
        state.submitLoading = true;
      })
      .addCase(updateCategory.fulfilled, (state, action) => {
          state.info = action.payload?.data.message;
          const index = state.datas.findIndex(
            (client) => client.id === action.payload.data.data.id,
          );
          state.datas[index] = {
            ...state[index],
            ...action.payload.data.data,
          };
         state.isSuccess = true;
        state.submitLoading = false;
        toast.success(action.payload?.data.message);
      })
      .addCase(updateCategory.rejected, (state, action) => {
        state.submitLoading = false;
        const errors = action.payload?.data?.errors;
        if (isEmpty(errors)) {
          toast.error(action.payload?.data?.message || 'Something went wrong');
        } else {
          state.formError = errors;
        }
      })
      .addCase(deleteCategory.pending, (state, action) => {
        state.submitLoading = true;
      })
      .addCase(deleteCategory.fulfilled, (state, action) => {
        const deletedId = action.meta.arg;
        state.datas = state.datas.filter(item => item.id !== deletedId);
        toast.success(action.payload?.data.message);
        state.submitLoading = false;
        state.isOpenCategoryDialog = false;
        state.pagination = {
          ...state.pagination,
          total: state.pagination.total > 0 ? state.pagination.total - 1 : 0,
        };
      })
      .addCase(deleteCategory.rejected, (state, action) => {
        state.error = action.payload?.data;
        state.submitLoading = false;
      });
  },
});

const { reducer } = categorySlice;

export const { openCategoryDialog } = categorySlice.actions;

export const categorySelector = (state) => state?.category;

export default reducer;
